import React from 'react'
import Select from 'react-select'
import {
  FormDashboardInput as Input,
  FormDashboardTextarea as Textarea,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  SaveButton,
  FormRow,
  SelectCheckbox
} from '../../../components'
import { ColorSelect } from '.'

// const issueOptions = [
//   {
//     label: 'Pemuda',
//     value: 'pemuda'
//   },
//   {
//     label: 'Perempuan',
//     value: 'perempuan'
//   },
//   {
//     label: 'Tokoh Agama',
//     value: 'tokohagama'
//   },
//   {
//     label: 'Pelajar',
//     value: 'pelajar'
//   },
//   {
//     label: 'Universitas',
//     value: 'universitas'
//   },
//   {
//     label: 'Korban',
//     value: 'korban'
//   },
// ]

const FormAbout = ({isMobile}) => {
  return (
    <form>
      <p className="text-lg font-bold mb-5 lg:mb-8">Organization Name</p>
      <FormRow>
        <Label>Name</Label>
        <Input className="w-full" defaultValue="Peace Generation Indonesia"/>
      </FormRow>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-8">
          <Label>Organization Type</Label>
          <Select className="text-sm" options={[]} placeholder="Choose Type"/>
        </div>
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-8">
          <Label>Suitable For</Label>
          <SelectCheckbox className="text-sm" placeholder="Choose"/>
        </div>
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Approach</Label>
          <Select className="text-sm" options={[]} placeholder="Choose Approach"/>
        </div>
        {/* <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Issues</Label>
          <SelectCheckbox className="text-sm" options={issueOptions} placeholder="Choose Issues"/>
        </div> */}
      </div>
      <FormRow last>
        <Label>Background Color Theme</Label>
        <ColorSelect />
      </FormRow>

      <hr className="my-5 lg:my-10"/>

      <p className="text-lg font-bold mb-5 lg:mb-10">About The Organization</p>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Team Member</Label>
          <Select className="text-sm" options={[]} />
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <Label>Total Member</Label>
          <Input className="w-full" defaultValue={31211} type="number"/>
        </div>
      </div>
      <FormRow>
        <ImagePickerSidebar
          label="Company Profile"
          height={isMobile ? "110px" : "100px"}
          buttonWidth={isMobile ? "190px" : "160px"}
        />
      </FormRow>
      <FormRow>
        <ImagePickerSidebar
          label="Featured Image"
          height={isMobile ? "150px" : "200px"}
          buttonWidth={isMobile ? "190px" : "160px" }
          message="JPG, GIF or PNG no larger than 1MB."
        />
      </FormRow>
      <FormRow>
        <Label>Highlight (English)</Label>
        <Textarea
          className="w-full"
          rows={isMobile ? 5 : 7}
          defaultValue={"Peace Generation Indonesia, atau kamu boleh juga memanggilnya Peacegen, adalah organisasi yang bergerak di bidang pendidikan perdamaian. Kami fokus pada pengembangan pelatihan perdamaian, media pembelajaran perdamaian, dan kegiatan kampanye serta aktivasi konten perdamaian. Kami berkomitmen untuk menyebarkan perdamaian dengan cara-cara yang ceria melalui media kreatif."}
        />
      </FormRow>
      <FormRow>
        <Label>Highlight (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={isMobile ? 5 : 7}
          defaultValue={"Peace Generation Indonesia, atau kamu boleh juga memanggilnya Peacegen, adalah organisasi yang bergerak di bidang pendidikan perdamaian. Kami fokus pada pengembangan pelatihan perdamaian, media pembelajaran perdamaian, dan kegiatan kampanye serta aktivasi konten perdamaian. Kami berkomitmen untuk menyebarkan perdamaian dengan cara-cara yang ceria melalui media kreatif."}
        />
      </FormRow>
      <FormRow>
        <Label>Additional Description (English)</Label>
        <Textarea
          className="w-full"
          rows={isMobile ? 10 : 15}
          defaultValue={
            `Lahirnya Peace Generation berawal dari pertemuan antara Irfan AmaLee dan Eric Lincoln di tahun 2006. Saat itu Eric menjadi guru bahasa Inggris di kantor Penerbit Mizan, di mana Irfan bekerja. Irfan menjadi salah satu siswa Eric. Di sela-sela belajar bahasa Inggris, Eric bertanya kepada siswanya tentang politik dunia. Irfan menjawab bahwa Amerika, tempat tinggal Eric, adalah sumber berbagai masalah. Saat itu Eric melihat Irfan sebagai seorang Taliban.
            Namun setelah itu, mereka mulai berbincang tentang banyak hal. Di luar dugaan, ternyata Irfan tak sepenuhnya seperti yang Eric bayangkan. Juga dengan Irfan, ia menyadari bahwa Eric tak seperti kebanyakan orang Amerika yang ia bayangkan. Mulai saat itu, semakin banyak yang mereka perbincangkan. Walau mereka memiliki perbedaan, terutama latar belakang, mereka juga memiliki banyak persamaan. Irfan dilahirkan di keluarga Muslim yang taat, begitu pun Eric yang juga dilahirkan di keluarga Kristen yang taat. Eric dan Irfan juga sama-sama tertarik di dunia pendidikan untuk remaja dan anak-anak. Akhirnya mereka berdua bersahabat, dan pada tahun 2007 mereka mendirikan Peace Generation Indonesia dengan modul 12 nilai perdamaian yang mereka rancang bersama.`
          }
        />
      </FormRow>
      <FormRow>
        <Label>Additional Description (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={isMobile ? 10 : 15}
          defaultValue={
            `Lahirnya Peace Generation berawal dari pertemuan antara Irfan AmaLee dan Eric Lincoln di tahun 2006. Saat itu Eric menjadi guru bahasa Inggris di kantor Penerbit Mizan, di mana Irfan bekerja. Irfan menjadi salah satu siswa Eric. Di sela-sela belajar bahasa Inggris, Eric bertanya kepada siswanya tentang politik dunia. Irfan menjawab bahwa Amerika, tempat tinggal Eric, adalah sumber berbagai masalah. Saat itu Eric melihat Irfan sebagai seorang Taliban.
            Namun setelah itu, mereka mulai berbincang tentang banyak hal. Di luar dugaan, ternyata Irfan tak sepenuhnya seperti yang Eric bayangkan. Juga dengan Irfan, ia menyadari bahwa Eric tak seperti kebanyakan orang Amerika yang ia bayangkan. Mulai saat itu, semakin banyak yang mereka perbincangkan. Walau mereka memiliki perbedaan, terutama latar belakang, mereka juga memiliki banyak persamaan. Irfan dilahirkan di keluarga Muslim yang taat, begitu pun Eric yang juga dilahirkan di keluarga Kristen yang taat. Eric dan Irfan juga sama-sama tertarik di dunia pendidikan untuk remaja dan anak-anak. Akhirnya mereka berdua bersahabat, dan pada tahun 2007 mereka mendirikan Peace Generation Indonesia dengan modul 12 nilai perdamaian yang mereka rancang bersama.`
          }
        />
      </FormRow>

      <SaveButton />
    </form>
  )
}

export { FormAbout }